import { render, staticRenderFns } from "./questions-check.vue?vue&type=template&id=dfff4b3e&scoped=true&"
import script from "./questions-check.vue?vue&type=script&lang=js&"
export * from "./questions-check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfff4b3e",
  null
  
)

export default component.exports